import React from 'react';
import {Form, Input, message, Select, Space} from "antd";
import {useBaseComponent} from "../../../../../base/base-component";
import server from "../../../../../server";

interface ICountryCodes {
    options: {
        value: string;
        label:React.ReactNode;
    }[];
}

interface ICountriesInfo {
    country: string;
    dialCode: string;
    countryCode: string;
    flagUrl: string;
}

interface IPersonalContactViewProps {

}

interface IState {
    countryCodes: ICountryCodes
}

const PersonalContactView = (props: IPersonalContactViewProps) => {

    const {state, updateState} = useBaseComponent<IPersonalContactViewProps, IState>(props, {
        initialState: () => ({
            countryCodes: {
                options: []
            }
        }),

        onInit: () => onInit()
    });

    async function onInit() {
        try {
            const res = await server.utils.countriesnow.getAllCountriesDialCodeAndFlag();
            const formattedResponse = res.data.map((data: any) => {
                return {
                    country: data.name,
                    dialCode: data.dialCode,
                    countryCode: data.unicodeFlag,
                    flagUrl: data.flag
                }
            })

            const seen = new Set<string>();

            const expandedCountries: ICountriesInfo[] = formattedResponse.flatMap((item: ICountriesInfo) => {
                const codes = item.dialCode
                    ? item.dialCode
                        .split(/and|,/i)
                        .map(code => code.trim())
                        .filter(Boolean)
                    : [];

                return codes.map(code => ({
                    ...item,
                    dialCode: code,
                }));
            });

            // Remove duplicates based on dial code
            const uniqueCountries = expandedCountries.filter(item => {
                if (seen.has(item.dialCode)) return false;
                seen.add(item.dialCode);
                return true;
            });
            generateOptionForDropdown(uniqueCountries);
        } catch (error) {
            console.log(error, 'error encountered');
            message.error("Error while fetching country codes and flags");
        }
    }

    function generateOptionForDropdown(res: ICountriesInfo[]) {
        const options = res.map((item: ICountriesInfo) => ({
            value: item.dialCode,
            label: (
                <div style={{display: "flex", alignItems: "center", gap: "8px"}} key={item.country}>
                    {item.flagUrl &&
                    <img src={item.flagUrl} alt={item.country} style={{width: "20px", height: "15px"}}/>}
                    <span>{item.dialCode}</span>
                </div>
            ),
        }));
        updateState('countryCodes.options', options);
    }

    return (
        <div className={'pn__employee-create__form__fixed-width personal-contact'}>
            <Form.Item
                label={'Mobile number'}
                className={"pn__employee-create__form-item"}
            >
                <Space.Compact>
                    <Form.Item
                        name={['personal', 'mobileNumber', 'countryCode']}
                        noStyle
                        rules={[{ required: true, message: 'Country code is required' }]}
                    >
                    <Select
                        showSearch
                        defaultValue="+91"
                        options={state.countryCodes.options}
                        className="countryFlagDropdown"
                    />
                    </Form.Item>
                    <Form.Item
                        name={['personal', 'mobileNumber','number']}
                        noStyle
                        required={true}
                        rules={[
                            {
                                required: true,
                                message: "Please enter mobile number",
                            },
                            () => ({
                                validator(_, value) {
                                    if (!value) return Promise.reject();
                                    if (isNaN(value)) {
                                        return Promise.reject("Mobile number has to be a number");
                                    }
                                    if (value.length < 10) {
                                        return Promise.reject("Mobile number can't be less than 10 digits");
                                    }
                                    if (value.length > 10) {
                                        return Promise.reject("Mobile number can't be more than 10 digits");
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Input placeholder="Enter mobile number"/>
                    </Form.Item>
                </Space.Compact>
            </Form.Item>

            <Form.Item
                label={"Alternate mobile number"}
                className={"pn__employee-create__form-item"}
            >
                <Space.Compact>
                    <Form.Item
                        name={['personal', 'alternateMobileNumber', 'countryCode']}
                        noStyle
                        rules={[{ required: true, message: 'Country code is required' }]}
                    >
                    <Select
                        showSearch
                        defaultValue="+91"
                        options={state.countryCodes.options}
                        className={'countryFlagDropdown'}
                    />
                    </Form.Item>
                    <Form.Item
                        name={['personal', 'alternateMobileNumber','number']}
                        noStyle
                        rules={[
                            () => ({
                                validator(_, value) {
                                    if (!value) {
                                        return Promise.resolve();
                                    }
                                    if (isNaN(value)) {
                                        return Promise.reject("Mobile number has to be a number");
                                    }
                                    if (value.length < 10) {
                                        return Promise.reject("Mobile number can't be less than 10 digits");
                                    }
                                    if (value.length > 10) {
                                        return Promise.reject("Mobile number can't be more than 10 digits");
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Input placeholder={'Enter alternate mobile number'}/>
                    </Form.Item>
                </Space.Compact>
            </Form.Item>

            <Form.Item
                name={['personal', 'alternateEmailId']}
                label={"Personal email id"}
                className={"pn__employee-create__form-item"}
                rules={[
                    {
                        type: 'email',
                        message: 'The input is not valid E-mail!',
                    }
                ]}
            >
                <Input placeholder={'Enter personal email id'}/>
            </Form.Item>
        </div>
    );
};

export default PersonalContactView;
